module.exports = __webpack_public_path__ + "static/img/background.f21b22bd.svg";